import zappy from "@zappy-ride/library.react.components";
import { FormVehicleInOperation } from "./FormVehicleInOperation";

export * from "./FormVehicleInOperation";

zappy.FactoryInstance.registerComponent(FormVehicleInOperation);
